import gql from 'graphql-tag';

import {
  GET_TIMESHEETS_FOR_PAYPERIOD,
  GET_WEEKLY_TIMESHEETS_HOURS_QUERY,
  WEEKLY_TIMESHEET_ENTRY_QUERY,
} from './index';

/*
* input: TimeEntryDestroyInput!
*   time_entries: [TimeEntryIdentityInputType]!
*     id: Int!
*     key: String!
*/

const TIME_ENTRY_DESTROY_MUTATION = gql`
  mutation TimeEntryDestroy($input: TimeEntryDestroyInput!) {
    time_entry_destroy(input: $input)
  }
`;

// TODO - with some API cleanup, adding 'ids' or keys to the gql object, some of the caches
// would update for free. As is, with no id (or even identical object types) cache can't work
// effectively.
export const deleteTimeEntryMutationGQL = (
  client,
  timeEntryId,
  timeEntryKey,
  supervisorId,
  userId,
  timesheetOriginDate,
) => {
  const entry = {
    id: timeEntryId,
    key: timeEntryKey,
  };

  const variables = {
    input: { time_entries: [entry] },
  };

  const options = {
    mutation: TIME_ENTRY_DESTROY_MUTATION,
    variables,
    refetchQueries: [
      {
        query: GET_TIMESHEETS_FOR_PAYPERIOD,
        variables: {
          supervisorId,
          approvalState: 'unapproved',
        },
      },
      {
        query: GET_WEEKLY_TIMESHEETS_HOURS_QUERY,
        variables: {
          userId,
          originDate: timesheetOriginDate,
        },
      },
      {
        query: WEEKLY_TIMESHEET_ENTRY_QUERY,
        variables: {
          userId,
          originDate: timesheetOriginDate,
        },
      },
    ],
  };

  return client.mutate(options);
};
